<template>
  <div id="app">
    <header>
      <h1>
        LELBI
        <span class="text-light">Foods</span>
      </h1>
      <h3>We offer delivery of spices at wholesale value.</h3>
    </header>
    <main class="card">
      <h4 class="text-light">Currently, we offer:</h4>
      <PriceSet />

      <h5 class="text-light">For enquiries, contact us:</h5>

      <a class="btn" v-bind:href="whatsAppLink" target="_blank">WhatsApp</a>
    </main>
    <footer>
      <h5>
        <span class="text-light">&copy; 2020</span>
        <a href="https://lelbi.com">Lelbi Group</a>
      </h5>
    </footer>
  </div>
</template>

<script>
import PriceSet from "./components/PriceSet.vue";

export default {
  name: "App",
  components: {
    PriceSet
  },
  data: function() {
    return {
      whatsAppLink: ""
    };
  },
  mounted: function() {
    const phoneNumber = "0918280282808";
    const defaultMessage = "Hello I am interested in buying spices";
    this.whatsAppLink = `https://wa.me/${phoneNumber}?text=${encodeURI(
      defaultMessage
    )}`;
  }
};
</script>

<style lang="scss">
:root {
  --base-bg: #e3eeff;
  --base-text-color: #001c47;
  --card-bg: #fbfbfb;
  --table-border: rgb(215, 215, 215);
  --table-head: rgb(188, 220, 255);
  --table-row: rgb(244, 244, 244);
  --sans-serif: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue",
    system-ui, sans-serif;
}
* {
  box-sizing: border-box;
}
html,
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--base-bg);
  color: var(--base-text-color);
  font-family: var(--sans-serif);
  margin: 0;
  padding: 1rem 0.5rem;
}
body {
  font-size: 14px;
  @media (min-width: 600px) {
    font-size: 16px;
  }
  @media (min-width: 960px) {
    font-size: 18px;
  }
  @media (min-width: 1200px) {
    font-size: 20px;
  }
}
#app {
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
}
.card {
  background: var(--card-bg);
  border-radius: 6px;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12);
  padding: 1rem;
  width: 100%;
  @media (min-width: 768px) {
    padding: 2rem;
  }
}
h1,
h3,
h4,
h5 {
  text-align: center;
}
.text-light {
  font-weight: 400;
}
.btn {
  background-color: #4f92ff;
  border-bottom: 2px solid #69a2ff;
  border-radius: 6px;
  color: #f2f2f2;
  display: block;
  margin: 20px auto;
  max-width: 300px;
  padding: 1rem 0;
  text-align: center;
  text-decoration: none;
  width: 100%;
}
.btn:hover,
.btn:focus {
  opacity: 0.9;
}
footer {
  margin: 1.5rem 10px 0;

  a {
    color: var(--base-text-color);
    margin-left: 10px;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
.warn {
  color: rgba(167, 92, 0, 0.851);
}
</style>
